<template>
  <div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop"
    >
      <div
        style="background: #fff;margin: 10px;border-radius:8px;padding: 10px 5px 5px 5px;"
      >
        <van-row>
          <van-col span="5">
            <div style="text-align: center;" @click="topToUrl('0')">
              <img
                style="width:26px;"
                src="https://www.ptty.com.cn/wap/XYWL.png?v=20250530"
              />
              <p style="font-size: 12px;margin-top: 3px;margin-bottom: 3px;">
                星耀未来系列
              </p>
            </div>
          </van-col>
          <van-col span="5">
            <div style="text-align: center;" @click="topToUrl('1')">
              <img
                style="width:24px;"
                src="https://www.ptty.com.cn/images/adminUpload/HPZG/202506/HPZG_336660786_20250624101214_50.png?v=20250624101214"
              />
              <p style="font-size: 12px;margin-top: 3px;margin-bottom: 3px;">
                挥拍中国
              </p>
            </div>
          </van-col>
          <van-col span="5">
            <div style="text-align: center;" @click="topToUrl('2')">
              <img
                style="width:22px;"
                src="https://www.ptty.com.cn/wap/XRXK.png?v=20250530"
              />
              <p style="font-size: 12px;margin-top: 3px;margin-bottom: 3px;">
                旭日杯系列
              </p>
            </div>
          </van-col>

          <van-col span="5">
            <div style="text-align: center;" @click="connectMe">
              <img
                style="width:26px;"
                src="https://www.ptty.com.cn/wap/shop.png?v=202"
              />
              <p style="font-size: 12px;margin-top: 3px;margin-bottom: 3px;">
                联系我们
              </p>
            </div>
          </van-col>
          <van-col span="4">
            <div style="text-align: center;" @click="myTrial">
              <img
                style="width:26px;"
                src="https://www.ptty.com.cn/wap/logo.png?v=20250530"
              />
              <p style="font-size: 12px;margin-top: 3px;margin-bottom: 3px;">
                我的比赛
              </p>
            </div>
          </van-col>
        </van-row>
      </div>
      <div
        id="adDiv"
        @click="connectMe"
        style="background-image: url(https://www.ptty.com.cn/wap/bbszpt.png?v=20250530);margin-left: 10px;margin-right:10px;border-radius: 8px;height: 5rem;background-size: 100% 100%;"
      >
        &nbsp;
      </div>

      <div style="padding-left: 10px;padding-right:10px;">
        <van-field
          style="margin-top:15px;margin-bottom:15px;"
          v-model="search.info"
          left-icon="search"
          center
          clearable
          label=""
          placeholder="请输入项目信息"
        >
          <template #button>
            <div
              @click="showCityPicker = true"
              style="float: left;padding-top: 6px;margin-right: 12px;font-weight: 600;"
            >
              <van-icon name="location-o" />
              <span>{{ selectedCity.city }}</span>
            </div>
            <van-button size="small" type="primary" @click="searchHandler">
              检索
            </van-button>
          </template>
        </van-field>

        <!-- 城市筛选 -->
        <van-field
          v-if="false"
          v-model="cityFieldValue"
          is-link
          readonly
          label="城市"
          placeholder="请选择省份/城市"
          @click="showCityPicker = true"
          right-icon="arrow"
          style="margin-bottom:15px;"
        >
          <template #button>
            <van-button
              v-if="cityFieldValue"
              size="small"
              type="default"
              @click.stop="clearCity"
              >清除</van-button
            >
          </template>
        </van-field>

        <van-row>
          <van-col span="24">
            <div
              @click="onBsztSelect({ value: '' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background:
                  bsztSelectData.value.length === 0 ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value.length === 0 ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              全部
            </div>
            <div
              @click="onBsztSelect({ value: '1' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '1' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '1' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              报名中
            </div>
            <div
              @click="onBsztSelect({ value: '3' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '3' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '3' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              排赛中
            </div>
            <div
              @click="onBsztSelect({ value: '6' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '6' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '6' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              比赛中
            </div>
            <div
              @click="onBsztSelect({ value: '7' })"
              v-bind:style="{
                float: 'left',
                padding: '7px 12px 7px 12px',
                fontSize: '13px',
                background: bsztSelectData.value === '7' ? '#185f9b' : '#fff',
                borderRadius: '5px',
                color: bsztSelectData.value === '7' ? '#fff' : 'black',
                marginRight: '9px'
              }"
            >
              已完赛
            </div>
          </van-col>
        </van-row>
      </div>

      <div
        class="itemContentMain"
        v-for="(item, index) in resultList"
        :key="index"
        @click="navToUrl(item.SSIDEN)"
      >
        <div
          v-if="item.FWCS > 100"
          style="position: absolute;top: 5px;left: 12px;color: rgb(118 117 117);font-size:14px;"
        >
          <van-icon name="eye-o" />
          {{ item.FWCS }}
        </div>
        <div
          style="position: absolute;right: 0px;top: 0px;"
          v-if="item.BSZT.length > 0"
        >
          <van-tag
            :type="
              item.BSZT === '1'
                ? 'primary'
                : item.BSZT === '3'
                ? 'danger'
                : item.BSZT === '6'
                ? 'warning'
                : item.BSZT === '7'
                ? 'success'
                : ''
            "
          >
            {{
              item.BSZT === "1"
                ? "报名中"
                : item.BSZT === "3"
                ? "排赛中"
                : item.BSZT === "6"
                ? "比赛中"
                : item.BSZT === "7"
                ? "比赛结束"
                : ""
            }}
          </van-tag>
        </div>
        <van-row>
          <van-col span="6">
            <van-image
              round
              width="60px"
              height="60px"
              :src="
                item.IMGURL.length > 0
                  ? item.IMGURL
                  : 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
              "
            />
            <div
              v-if="item.ISVIDIOZB === '1' || item.ISIMGZB === '1'"
              style="isplay: flex;align-items: center;justify-content: left;display: flex;margin-top:2px;background: #fff;border: none;"
            >
              <img
                v-if="item.ISVIDIOZB === '1'"
                style="width:15px;"
                src="https://www.ptty.com.cn/wap/spZb.png"
              />
              <img
                v-if="item.ISIMGZB === '1'"
                style="width:15px;margin-left: 21px;"
                src="https://www.ptty.com.cn/wap/imgZb.png"
              />
            </div>
          </van-col>
          <van-col span="18">
            <div class="contentMainDivClass">
              <div
                style="font-size: 16px;font-weight: 800;padding-bottom: 5px;"
              >
                {{ item.SSMC }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BSQSRQ.length > 0"
              >
                比赛日期：{{ item.BSQSRQ }} 至 {{ item.BSJZRQ }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.CITYNAME.length > 0"
              >
                举办城市：{{
                  item.SFNAME === item.CITYNAME
                    ? item.CITYNAME
                    : item.SFNAME + " - " + item.CITYNAME
                }}{{
                  item.SSIDEN ===
                  "6e79312f4e774c6342706673646f62366e39736e493562413832477437646d76"
                    ? "（龙南市）"
                    : ""
                }}
              </div>
              <div style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;">
                比赛地址：{{ item.CGMC }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名起始时间：{{ item.BMQSRQ }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名截止时间：{{ item.BMJZRQ }}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>

      <div
        style="text-align: center;margin-top: 15px;font-size:13px;color:rgb(104, 104, 104)"
        @click="loadingGdHandler"
        v-if="resultList.length > 0"
      >
        <span>{{ isEndPage ? "已加载全部" : "点击加载更多" }}</span>
        <van-icon name="arrow-down" v-if="!isEndPage" />
      </div>
      <van-empty description="数据不存在" v-if="resultList.length === 0" />

      <div class="footer-section">
        <div class="footer-content">
          <div class="footer-logo">
            <img
              src="https://www.ptty.com.cn/wap/logo.png?v=20250530"
              alt="跑兔体育"
            />
          </div>
          <div class="footer-copyright">
            天津跑兔体育科技有限公司©版权所有
          </div>
          <div class="footer-icp">
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >津ICP备2023005649号</a
            >
          </div>
          <div class="footer-divider"></div>
          <div class="footer-slogan">
            专业体育赛事服务平台
          </div>
        </div>
      </div>
      <div style="height:150px;width:15px;"></div>
    </van-pull-refresh>
    <!--比赛类型  开始-->
    <van-action-sheet
      v-model="qslxVisible"
      :actions="qxlxActive"
      @select="onQslxSelect"
    />
    <!--比赛类型  结束-->

    <!--比赛状态  开始-->
    <van-action-sheet
      v-model="bsztShow"
      :actions="bsztActions"
      @select="onBsztSelect"
    />
    <!--比赛状态  结束-->

    <!-- 城市选择弹窗 开始 -->
    <van-popup
      v-model="showCityPicker"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div
        style="padding: 15px; height: 100%; display: flex; flex-direction: column;"
      >
        <van-search
          v-model="citySearchValue"
          placeholder="搜索省份或城市"
          @input="onCitySearch"
          style="flex-shrink: 0;"
        />
        <div
          v-if="citySearchValue"
          style="flex: 1; overflow-y: auto; margin-top: 10px;"
        >
          <van-cell
            v-for="city in filteredCities"
            :key="city.value"
            :title="city.text"
            is-link
            @click="onCitySelect(city)"
          />
          <van-empty
            v-if="filteredCities.length === 0"
            description="未找到相关城市"
          />
        </div>
        <van-cascader
          v-else
          v-model="cascaderValue"
          title="请选择省份/城市"
          :options="cityOptions"
          @close="showCityPicker = false"
          @finish="onCascaderFinish"
          style="flex: 1;"
        />
      </div>
    </van-popup>
    <!-- 城市选择弹窗 结束 -->

    <!-- 底部导航栏 开始 -->
    <van-tabbar v-model="bottomMenuActive">
      <van-tabbar-item icon="home-o" @click="tabNavToUrl">主页</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="tabNavToUrl"
        >个人中心</van-tabbar-item
      >
    </van-tabbar>
    <!-- 底部导航栏 结束 -->

    <bottom-com></bottom-com>

    <loading-com />

    <!-- 返回顶部按钮 -->
    <back-to-top-com @back-to-top="onBackToTop" />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import BackToTopCom from "../commonCom/BackToTopCom.vue";
import BottomCom from "../commonCom/BottomCom.vue";
export default {
  components: { HeaderCom, LoadingCom, BackToTopCom, BottomCom },
  name: "Index",

  data() {
    return {
      resultList: [],
      isEndPage: false,
      isLoading: false,
      bottomMenuActive: 0,
      op: "wapGL",
      qslxVisible: false,
      qxlxActive: [
        { name: "全部", value: "" },
        { name: "羽毛球", value: "1" }
      ],
      bsztShow: false,
      bsztActions: [
        { name: "全部", value: "" },
        { name: "报名中", value: "1" },
        { name: "排赛中", value: "3" },
        // { name: "发布秩序册", value: "5" },
        { name: "比赛中", value: "6" },
        { name: "比赛结束", value: "7" }
      ],
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        city: ""
      },
      qslxSelectData: { name: "比赛类型", value: "" },
      bsztSelectData: { name: "比赛状态", value: "" },
      ryInfo: {
        NIC: "点击登录",
        TEL: "",
        isLogin: false
      },
      openIdEn: "",
      // 城市选择相关
      showCityPicker: false,
      cityFieldValue: "",
      citySearchValue: "",
      cascaderValue: "",
      selectedCity: { province: "", city: "全国", value: "" },
      cityOptions: [],
      allCities: [],
      isAtTop: true // 是否在顶部
    };
  },
  created() {
    localStorage.setItem("routeValue", "");
    this.utilPost = this.$util.handler;
  },
  mounted() {
    localStorage.setItem("routeValue", "");
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      var that = this;
      this.utilPost.getOpenId(function(openId) {});
    }
    this.resultList = [];
    // 初始化城市数据
    this.initCityData();
    //必须等界面渲染完成后 在加载
    this.mainLoadData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
    // this.utilPost.tencentAdInitSdk();
    setTimeout(() => {
      this.$nextTick(() => {
        this.utilPost.loadAdHandler("adDiv");
      });
    }, 300);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    getWxShopUrl() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: "",
          op: this.op, //反射名称
          methodName: "wxShopeH5Url" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        window.location.href = data.content;
      });
    },
    topToUrl(item) {
      switch (item) {
        case "0": {
          window.location.href = "https://www.ptty.com.cn/wap/#/indexXywl";
          break;
        }
        case "1": {
          window.location.href = "https://www.ptty.com.cn/wap/#/indexZtHpzg";
          break;
        }
        case "2": {
          window.location.href = "https://www.ptty.com.cn/wap/#/indexXrxk";

          break;
        }
      }
    },
    connectMe() {
      this.$router.push({ path: "/connectMe" });
    },
    myTrial() {
      // this.$router.push({ path: "/connectMe" });
      const openIdEn = localStorage.getItem("openIdEn");
      if (!openIdEn) {
        this.$router.push("/loginIndex");
        return;
      }
      const ryInfoLocal = localStorage.getItem("ryInfo");
      if (!ryInfoLocal) this.$router.push("/loginIndex");

      this.$router.push("/meBsIndex");
    },
    searchHandler() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    onRefresh() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    loadingGdHandler() {
      if (this.isEndPage) {
        return;
      }
      this.pageSet.currentPage = this.pageSet.currentPage + 1;
      this.mainLoadData();
    },
    mainLoadData() {
      //alert(JSON.stringify(this.pageSet));
      this.search.qslx = this.qslxSelectData.value;
      this.search.bszt = this.bsztSelectData.value;
      var busData = {
        pageSet: this.pageSet,
        search: this.search,
        selectedCity: this.selectedCity
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        for (var a = 0; a < data.content.length; a++) {
          this.resultList.push(data.content[a]);
        }

        if (
          data.content.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        this.isLoading = false;
      });
    },
    navToUrl(ssidEn) {
      this.$router.push({ path: "/xmIndex", query: { ssid: ssidEn } });
    },
    openQslxModal() {
      this.qslxVisible = true;
    },
    onQslxSelect(item) {
      this.pageSet.currentPage = 1;
      this.qslxSelectData = item;
      this.qslxVisible = false;
      this.resultList = [];
      this.mainLoadData();
    },
    //打开比赛状态Model
    openBsztModal() {
      this.bsztShow = true;
    },
    onBsztSelect(item) {
      this.pageSet.currentPage = 1;
      this.bsztSelectData = item;
      this.bsztShow = false;
      this.resultList = [];
      this.mainLoadData();
    },
    tabNavToUrl() {
      switch (this.bottomMenuActive) {
        case 0: {
          var routeValue = localStorage.getItem("routeValue");
          if (
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
          ) {
            this.$router.push({ path: "/" });
          } else {
            this.$router.push({ path: "/" + routeValue });
          }
          break;
        }
        case 1: {
          this.$router.push({ path: "/meIndex" });
          break;
        }
      }
    },
    // 返回顶部事件处理
    onBackToTop() {
      // 可以在这里添加额外的逻辑，比如刷新数据等
      console.log("返回顶部");
    },
    // 初始化城市数据
    initCityData() {
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getWapCityList" //对应的方法名
        },
        busData: {} //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // 中国省市数据
        this.cityOptions = data.content;

        // 构建扁平化的城市列表用于搜索
        this.allCities = [];
        this.cityOptions.forEach(province => {
          province.children.forEach(city => {
            this.allCities.push({
              text: `${province.text} - ${city.text}`,
              value: city.value,
              province: province.text,
              city: city.text
            });
          });
        });
      });
    },
    // 城市搜索
    onCitySearch() {
      // 搜索逻辑在计算属性中处理
    },
    // 级联选择完成
    onCascaderFinish({ selectedOptions }) {
      this.showCityPicker = false;
      if (selectedOptions.length === 2) {
        this.selectedCity = {
          province: selectedOptions[0].text,
          city: selectedOptions[1].text,
          value: selectedOptions[1].value
        };
        this.cityFieldValue = `${selectedOptions[0].text} - ${selectedOptions[1].text}`;
        this.search.city = selectedOptions[1].text;
        // 重新加载数据
        this.resultList = [];
        this.pageSet.currentPage = 1;
        this.mainLoadData();
      }
    },
    // 从搜索结果中选择城市
    onCitySelect(city) {
      this.showCityPicker = false;
      this.selectedCity = {
        province: city.province,
        city: city.city,
        value: city.value
      };
      this.cityFieldValue = `${city.province} - ${city.city}`;
      this.search.city = city.city;
      this.citySearchValue = "";
      // 重新加载数据
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    // 清除城市选择
    clearCity() {
      this.cityFieldValue = "";
      this.search.city = "";
      this.selectedCity = { province: "", city: "", value: "" };
      this.cascaderValue = "";
      // 重新加载数据
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    }
  },
  computed: {
    filteredCities() {
      if (!this.citySearchValue) {
        return [];
      }
      const keyword = this.citySearchValue.toLowerCase();
      return this.allCities.filter(city => {
        return (
          city.province.toLowerCase().includes(keyword) ||
          city.city.toLowerCase().includes(keyword)
        );
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 12px;
  padding: 16px;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  overflow: hidden;
  /* 性能优化 */
  contain: layout style paint;
  content-visibility: auto;
}
.van-image--round {
  margin-top: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 3px solid #fff;
}

.van-tag {
  font-size: 13px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.contentMainDivClass {
  padding-top: 15px;
}

/* 美化访问次数显示 */
.itemContentMain > div[style*="position: absolute"] {
  z-index: 2;
}

.itemContentMain > div[style*="left: 12px"] {
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  top: 12px !important;
  left: 16px !important;
}

/* 美化状态标签位置 */
.itemContentMain > div[style*="right: 0px"] {
  border-radius: 0 16px 0 16px;
  overflow: hidden;
}

.itemContentMain > div[style*="right: 0px"] .van-tag {
  border-radius: 0 16px 0 16px !important;
  margin: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 美化直播标签 */
.itemContentMain [style*="display: flex"] {
  background: rgba(24, 95, 155, 0.05);
  padding: 5px;
  border-radius: 12px;
  margin-top: 4px !important;
  border: 1px solid rgba(24, 95, 155, 0.1);
}

/* 响应式优化 */
@media (max-width: 768px) {
  .itemContentMain {
    margin: 8px;
    padding: 12px;
    border-radius: 12px;
  }

  .itemContentMain > div[style*="left: 12px"] {
    top: 8px !important;
    left: 12px !important;
    padding: 4px 8px;
    font-size: 12px;
  }

  .van-image--round {
    margin-top: 36px;
  }
  /* 移动端底部样式优化 */
  .footer-section {
    margin-top: 30px;
    padding: 20px 15px;
    border-radius: 15px 15px 0 0;
  }

  .footer-content {
    gap: 10px;
  }

  .footer-logo img {
    width: 35px;
    height: 35px;
  }

  .footer-copyright {
    font-size: 13px;
  }

  .footer-icp a {
    font-size: 11px;
    padding: 5px 10px;
  }

  .footer-slogan {
    font-size: 11px;
  }
}

/* 底部区域美化 */
.footer-section {
  margin-top: 40px;
  position: relative;
  overflow: hidden;
  background: #fff;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 15px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  max-width: 400px;
  margin: 0 auto;
}

.footer-logo {
  margin-bottom: 8px;
}

.footer-logo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.15);
}

.footer-copyright {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  line-height: 1.5;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-icp {
  margin-top: 4px;
}

.footer-icp a {
  font-size: 12px;
  color: #7f8c8d;
  text-decoration: none;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-block;
}

.footer-divider {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #185f9b, transparent);
  margin: 8px 0;
  border-radius: 1px;
}

.footer-slogan {
  font-size: 12px;
  color: #95a5a6;
  font-style: italic;
  opacity: 0.8;
  letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Index.vue